module.exports = __webpack_public_path__ + "img/partner.741e597e.png";